import React from 'react';
import ATMPageHeader from 'src/components/UI/atoms/ATMPageHeader/ATMPageHeader';
import ATMPagination from 'src/components/UI/atoms/ATMPagination/ATMPagination';
import ATMTable, {
  columnTypes,
} from 'src/components/UI/atoms/ATMTable/ATMTable';
import SideNavLayout from 'src/components/layouts/SideNavLayout/SideNavLayout';

type Props = {
  columns: columnTypes[];
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
    setIsOpenAddDialog: (newValue: boolean) => void;
  };
};

const ExpenseCategoriesListing = ({
  columns,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
    setIsOpenAddDialog,
  },
}: Props) => {
  return (
   <SideNavLayout>
     <div className='flex flex-col h-full p-4'>
      {/* Page Header */}
      <div className='p-4'>
        <ATMPageHeader
        moduleName='EXPENSE_CATEGORY'
          pageTitle='Expense Category '
          searchValue={searchValue}
          onSearchChange={setSearchValue}
          buttonProps={{
            btnName: 'Add New',
            onClick: () => {
              setIsOpenAddDialog(true)
            },
          }}
        />
      </div>

      {/* Table */}
      <div className='flex-1 overflow-auto flex flex-col'>
        <ATMTable
          columns={columns}
          rows={rows}
          rowExtraClasses={() => 'min-h-[40px]'}
          isLoading={isTableLoading}
        />
      </div>

      <div className='p-4 py-2'>
        <ATMPagination
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={setPage}
          onRowsPerPageChange={setRowsPerPage}
          rowCount={totalItems}
          rows={rows}
        />
      </div>
    </div>
   </SideNavLayout>
  );
};

export default ExpenseCategoriesListing;